import { requests } from "../config";
import { IOrderRehesh, IPatchStatusOrderLine } from "./models/order";

export const Rehesh = {
    //DateFrom=${date}&DateTo=${date}
    getOrders: (date: string): Promise<IOrderRehesh[]> => requests.get(`order/supply_details?${date}`, 'go'),
    patchStatusOrderLine: (data: IPatchStatusOrderLine[]) => requests.put(`order/detail_status`, 'go', data),
    postOrderSupplyDetails: (data: IOrderRehesh[]): Promise<IOrderRehesh[]> => requests.post(`order/supply_details`, 'go', data),
}
